import { Rating } from "primereact/rating";
import React from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { submitReview } from "../../Services/MainService";

export const ServiceReview = () => {
  const [value, setValue] = React.useState(0);
  const [comment, setComment] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const navigate = useNavigate();
  const onSubmit = () => {
    const payload = {
      comments: comment,
      stars: value,
    };
    if (!submitting) {
      setSubmitting(true);
      submitReview(payload).then(
        (res) => {
          setSubmitting(false);
          toast.success(res.message);
          setComment("");
          setValue(0);
          navigate("/app", { replace: true });
        },
        (er) => {
          setSubmitting(false);
          if (er && er.errors?.length > 0) {
            er.errors.forEach((x) => {
              toast.error(x.message);
            });
          }
        }
      );
    }
  };
  return (
    <>
      <div
        className="container d-flex"
        style={{ minHeight: "calc(80vh - 70px)" }}
      >
        <div className="row align-items-center justify-content-center" style={{ flex: 1 }}>
          <div className="col-xl-4 col-lg-6 col-md-8 col-12 text-center">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/noitemicon.png"}
              alt=""
              style={{ width: "70px" }}
              className="mb-3"
            />
            <h3>How was our service?</h3>
            <p>Was it good? Let's talk about it.</p>
            <div className="d-flex justify-content-center align-items-center pb-2">
              <Rating
                value={value}
                onChange={(e) => setValue(e.value)}
                cancel={false}
                readOnly={false}
                disabled={false}
              />
            </div>
            <hr style={{ borderStyle: "dashed" }} />
            <input
              type="text"
              className="form-control"
              placeholder="Share your thoughts."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center"
            style={{ columnGap: "20px" }}
          >
            <div className="service-btn next" onClick={() => onSubmit()}>
              {submitting ? <Spinner className="me-1" size="sm" /> : null}
              Submit Review
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
